import type { ComponentProps } from 'react';

/**
 * 画鋲（thumbtack）型のピンアイコン
 *
 * heroicons には画鋲型のアイコンが存在しないため、`stroke="currentColor"` /
 * `strokeWidth="1.5"` の outline スタイルに合わせた自前 SVG を提供する。
 * 「固定」「ピン留め」（チャット履歴の重要スレッドを上部に固定する機能等）を
 * 表す UI で `BookmarkIcon` 等の代わりに使用する。
 */
export const PinIcon = (props: ComponentProps<'svg'>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 17v5M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z"
    />
  </svg>
);
